import ResetPassword from './reset-password-container'

export default ResetPassword
